export default "/images/sensonsImgPlaceholder2.png?53738bcc69d7fcfa50b366b22c747e04";